import { UserAdapters } from '../adapters';
import { LOCATION_COUNTS_MAX_IDS, UsersApi } from '../clients';
import { toBatches } from './toBatches';

/**
 * How many locations each identity can access, keyed by identity id.
 *
 * In as many requests as organization-service's id cap needs: an office's
 * Location Admins tab is unpaged, and an office on dev has over a hundred
 * identities. One failed batch fails the whole read, so the caller never shows
 * some counts as loaded and the rest as missing.
 *
 * @param {string[]} identityIds - See `clients/GetIdentityLocationCounts`.
 * @returns {Promise<Object<string, number>>}
 */
export const getIdentityLocationCounts = async (identityIds) => {
  const batches = toBatches(identityIds, LOCATION_COUNTS_MAX_IDS);
  const responses = await Promise.all(
    batches.map((batch) => UsersApi.getIdentityLocationCounts(batch)),
  );

  return Object.assign(
    {},
    ...responses.map((response) => UserAdapters.toLocationCountsById(response)),
  );
};
